import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Maria G.',
    location: 'Pompano Beach, FL',
    text: 'Aria Property Improvement, LLC took care of our bathroom renovations and they look absolutely amazing. Very professional and detail-oriented.',
    rating: 5,
  },
  {
    id: 2,
    name: 'David R.',
    location: 'Fort Lauderdale, FL',
    text: 'The details in our kitchen renovation are astounding, very happy with the results. I\'d recommend them to anyone.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Jennifer K.',
    location: 'Boca Raton, FL',
    text: 'We contracted members of our property improvement LLC at our apartment and they were very professional and very keen.',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" ref={sectionRef} className="bg-white py-16 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div
            className={`flex items-center justify-center gap-4 md:gap-6 mb-10 md:mb-14 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="h-px bg-teal flex-1 max-w-[100px] md:max-w-[160px]"></div>
            <h2 className="font-heading font-bold text-charcoal text-xl md:text-2xl lg:text-3xl text-center whitespace-nowrap">
              What Our Customers Say
            </h2>
            <div className="h-px bg-teal flex-1 max-w-[100px] md:max-w-[160px]"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`bg-white rounded-lg p-6 md:p-8 border border-concrete transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center">
                    <span className="font-heading font-bold text-teal text-sm">
                      {testimonial.name.split(' ')[0][0]}
                      {testimonial.name.split(' ')[1][0]}
                    </span>
                  </div>
                  <div>
                    <p className="font-heading font-semibold text-charcoal text-sm">{testimonial.name}</p>
                    <p className="font-body text-charcoal/50 text-xs">{testimonial.location}</p>
                  </div>
                </div>
                <p className="font-body text-charcoal/80 text-sm leading-relaxed mb-4">
                  {testimonial.text}
                </p>
                <div className="flex items-center gap-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <div key={star} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-teal text-sm"></i>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}